<div class="confirm-modal ig-modal show-event-times-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <h3>{{data.title}}</h3>

    <div class="event-times-wrap">
        <ng-container>
            <div *ngFor="let time of data.eventTimes">
                <div>{{time.startTimeFormatted}} - {{time.endTimeFormatted}}</div>
            </div>
        </ng-container>

<!--        <ng-container *ngIf="data.isManualTime">-->
<!--            <div *ngFor="let time of data.eventTimesText">-->
<!--                <div>{{time.startTimeText+data.timezone}} - {{time.endTimeText+data.timezone}}</div>-->
<!--            </div>-->
<!--        </ng-container>-->
    </div>

    <br/>

    <ig-row [pinCenter]="true">
        <ig-col [xs]="6">
            <ig-button class="btn-primary" #confirmButton color="primary" size="md"
                       (trigger)="confirm()">
                OK
            </ig-button>
        </ig-col>
    </ig-row>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/show.more.event.times.modal/show.more.event.times.modal.component.html